import getStateLicenseType from 'data/LicenseTypes/getStateLicenseType';
import getAvailableLicenses from 'data/LicenseTypes/getAvailableLicenses';
import React from 'react';
import PropTypes from 'prop-types';
import LicensePanelDisplay from './LicensePanelDisplay';

const getNewLicense = () => {
  const EffectiveDate = new Date();
  let year = EffectiveDate.getFullYear();
  year += 1;
  const ExpirationDate = new Date();
  ExpirationDate.setFullYear(year);
  return ({
    LicenseNumber: undefined,
    RegionId: 0,
    EffectiveDate,
    ExpirationDate,
    DoesNotExpire: false
  });
};

const getHomeStateFromProps = (props) => {
  if (props.account && props.account.carrierAccount) {
    return props.account.carrierAccount.HomeState;
  }
  return undefined;
};

class LicensePanelContainer extends React.Component {
  static propTypes = {
    loadLicenses: PropTypes.func.isRequired,
    loadSingleLicense: PropTypes.func.isRequired,
    saveLicense: PropTypes.func.isRequired,
    postLicenseReset: PropTypes.func.isRequired,
    loadAccount: PropTypes.func.isRequired,
    closePanel: PropTypes.func.isRequired,
    licensePanelOpen: PropTypes.bool.isRequired,
    onSubmitted: PropTypes.func.isRequired,
    panelLabel: PropTypes.string,
    editId: PropTypes.string,
    posting: PropTypes.bool,
    account: PropTypes.shape({
      loading: PropTypes.bool,
      carrierAccount: PropTypes.shape({
        HomeState: PropTypes.string,
        IsProducer: PropTypes.bool
      })
    })
  };

  static defaultProps = {
    editId: undefined,
    panelLabel: undefined,
    posting: undefined,
    account: { carrierAccount: {} }
  }

  state={
    license: getNewLicense(),
    errors: {},
    panelCloseState: undefined,
    availableLicenses: []
  };

  componentDidMount() {
    if (this.props.editId) {
      this.props.loadSingleLicense(this.props.editId);
    }
    if (this.props.account.carrierAccount == null && !this.props.account.loading) {
      this.props.loadAccount();
    }
    if (getHomeStateFromProps(this.props) != null) {
      const { HomeState, IsProducer } = this.props.account.carrierAccount;
      this.setState({
        availableLicenses: getAvailableLicenses(HomeState, IsProducer)
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.posting !== prevProps.posting && this.props.posting === false) {
      this.panelToggle();
      this.props.onSubmitted();
    }
    if (this.props.license && this.props.license !== prevProps.license) {
      const { license } = this.props;
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        license: { ...license }
      });
    }
    const lastHomeState = getHomeStateFromProps(prevProps);
    const homeState = getHomeStateFromProps(this.props);
    if (homeState !== lastHomeState) {
      const { HomeState, IsProducer } = this.props.account.carrierAccount;
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        availableLicenses: getAvailableLicenses(HomeState, IsProducer)
      });
    }
  }

  handleOnChange = (newValue) => {
    const stateLicenseType = getStateLicenseType(newValue.RegionId);
    if (stateLicenseType != null && stateLicenseType.NoLicenseRequired) {
      this.setState({
        license: {
          ...newValue,
          LicenseNumber: 'Not Required',
          DoesNotExpire: true,
          ExpirationDate: null
        }
      });
    } else {
      if (this.state.license.DoesNotExpire === false && newValue.DoesNotExpire === true) {
        newValue.ExpirationDate = null;
      }
      this.setState({ license: newValue });
    }
  }

  clearErrors = () => {
    const errors = {};
    this.setState({ errors });
  }

  clearLicense = () => {
    this.setState({ license: getNewLicense() });
  }

  validateForm = () => {
    this.clearErrors();
    let isValid = true;
    const { license } = this.state;
    const errors = {};

    if (license.ExpirationDate && license.ExpirationDate < license.EffectiveDate) {
      errors.ExpirationDate = 'Expiration Date is before Effective Date';
      isValid = false;
    }

    if (license.RegionId == null || license.RegionId === 0) {
      errors.RegionId = 'Please pick a license type';
      isValid = false;
    }

    if (license.LicenseNumber === '' || license.LicenseNumber === undefined) {
      errors.LicenseNumber = 'Please enter a license number';
      isValid = false;
    }

    if (isValid === false) {
      return errors;
    }
    return null;
  };

  handleSave = () => {
    const { license } = this.state;
    const errors = this.validateForm();
    if (errors === null) {
      const stateLicenseType = getStateLicenseType(license.RegionId);
      const licenseToSave = {
        ...license,
        LicenseTypeId: stateLicenseType.LicenseTypeId
      };
      if (this.props.editId) {
        this.props.editLicense(licenseToSave);
      } else {
        this.props.saveLicense(licenseToSave);
      }
    } else {
      this.setState({ errors });
    }
  }

  panelToggle = () => {
    if (this.state.panelCloseState !== undefined && this.state.panelCloseState === true) {
      this.props.closePanel();
    }
    this.setState({ panelCloseState: undefined });
  }

  saveWithClose = () => {
    this.setState({ panelCloseState: true }, () => this.handleSave());
  }

  saveWithoutClose = () => {
    this.setState({ panelCloseState: false }, () => this.handleSave());
  }

  render() {
    const { panelLabel, editId } = this.props;
    const { availableLicenses } = this.state;
    return (
      <LicensePanelDisplay
        { ...this.props }
        value={ this.state.license }
        errors={ this.state.errors }
        onChange={ this.handleOnChange }
        saveWithClose={ this.saveWithClose }
        saveWithoutClose={ this.saveWithoutClose }
        panelLabel={ panelLabel }
        editId={ editId }
        availableLicenses={ availableLicenses }
      />
    );
  }
}

export default LicensePanelContainer;
